import { Folder } from 'lucide-react';

import { AppShell, Breadcrumbs } from '@/components/landing/AppShell';

/**
 * Placeholder route so the sidebar Assets entry resolves cleanly. Full
 * asset manager (library browser + per-pack manifest viewer) lands later;
 * shipping a "coming soon" body here avoids 404 redirects on click.
 */
export default function AssetsPage() {
  return (
    <AppShell activeNav="assets">
      <div className="mx-auto flex w-full max-w-[1100px] flex-col px-8 pt-6 pb-16">
        <Breadcrumbs
          items={[
            { label: 'Workspace', href: '/lesson-packs' },
            { label: 'Assets' },
          ]}
        />

        <div className="mt-3">
          <h1 className="text-[26px] font-semibold tracking-tight text-fg">
            Assets
          </h1>
          <p className="mt-1 text-sm text-fg-muted">
            Library of generated images and uploads used across lesson packs.
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center justify-center rounded-xl border-2 border-dashed border-border bg-bg-panel/50 py-16 text-center">
          <span className="grid h-14 w-14 place-items-center rounded-xl bg-accent-soft text-accent">
            <Folder size={24} />
          </span>
          <h3 className="mt-4 text-base font-semibold text-fg">Coming soon</h3>
          <p className="mt-1.5 max-w-sm text-[13px] text-fg-muted">
            For now, manage per-pack assets from the pack detail page — the
            publish step builds an asset manifest you can inspect there.
          </p>
        </div>
      </div>
    </AppShell>
  );
}
